import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

const POPULAR_CITIES = [
  "Vadodara",
  "Ahmedabad",
  "Surat",
  "Mumbai",
  "Pune",
];

export default function CitySelector({ isOpen, onClose, onCitySelect }) {
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        // Check if click is on location selector
        const locationSelector = event.target.closest('.location-selector');
        if (!locationSelector) {
          onClose();
        }
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [isOpen, onClose]);

  // Handle escape key
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  // Prevent body scroll when dropdown is open on mobile
  useEffect(() => {
    if (isOpen && window.innerWidth <= 768) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const filteredCities = POPULAR_CITIES.filter((city) =>
    city.toLowerCase().includes(search.toLowerCase())
  );

  const detectLocation = () => {
    if (!navigator.geolocation) {
      alert("Geolocation not supported");
      return;
    }

    onCitySelect("Detecting...");
    onClose();

    navigator.geolocation.getCurrentPosition(
      () => {
        setTimeout(() => onCitySelect("Vadodara"), 1200);
      },
      () => {
        onCitySelect("Vadodara");
      }
    );
  };

  const handleCityClick = (city) => {
    if (city === "Detect Location") {
      detectLocation();
    } else {
      onCitySelect(city);
      onClose();
    }
  };

  return (
    <div className="city-dropdown" ref={dropdownRef}>
      {/* Close button for mobile */}
      {window.innerWidth <= 768 && (
        <div className="city-dropdown-close" onClick={onClose}>
          <i className="ri-close-line"></i>
        </div>
      )}
      
      {/* Search */}
      <div className="city-search-container">
        <i className="ri-search-line"></i>
        <input
          className="city-search-input"
          placeholder="Search city..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          autoFocus
        />
      </div>

      <ul className="city-list">
        {/* Detect location FIRST */}
        <li className="city-item detect-location" onClick={() => handleCityClick("Detect Location")}>
          <i className="ri-focus-3-line"></i>
          Detect My Location
        </li>

        <li className="city-divider"></li>

        <li className="city-header">POPULAR CITIES</li>

        {filteredCities.length > 0 ? (
          filteredCities.map((city) => (
            <li
              key={city}
              className="city-item"
              onClick={() => handleCityClick(city)}
            >
              <i className="ri-map-pin-line"></i>
              {city}
            </li>
          ))
        ) : (
          <li className="city-item">
            <i className="ri-search-line"></i>
            No cities found
          </li>
        )}
      </ul>
    </div>
  );
}

CitySelector.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCitySelect: PropTypes.func.isRequired,
};